import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { environment } from "../../../environments/environment";
import { Product, ProductInventory } from "../../models/product.model";
import { ProductInventoryService } from "../../services/product-inventory.service";
import { ProductService } from "../../services/product.service";
import * as _ from "lodash";

@Component({
  selector: "ngx-dialog-product-inventory",
  templateUrl: "dialog-product-inventory.component.html",
  styleUrls: ["dialog-product-inventory.component.scss"],
})
export class DialogProductInventoryComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() product: Product;
  @Input() isReceive: boolean;
  @Input() isEdit: boolean = false;
  @Input() prodInventory?: ProductInventory = new ProductInventory();

  prodInventoryBackup?: ProductInventory = new ProductInventory();

  loading = false;
  submitted = false;

  issueDate: Date = new Date();
  quantity = 1;
  price = 0;
  amount = 0;
  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";

  constructor(
    protected ref: NbDialogRef<DialogProductInventoryComponent>,
    private inventoryService: ProductInventoryService,
    private productService: ProductService
  ) {}

  ngOnInit() {
    console.log("ngOnInit:", this.prodInventory);
    this.prodInventoryBackup = _.clone(this.prodInventory);

    if (this.isEdit) {
      this.isReceive = this.prodInventory.isReceive;
      this.issueDate = this.prodInventory.issueDate;
      if (this.isReceive) {
        this.quantity = this.prodInventory.receiveQuantity;
        this.price = this.prodInventory.receivePrice;
        this.amount = this.prodInventory.receiveQuantity;
      } else {
        this.quantity = this.prodInventory.issueQuantity;
        this.price = this.prodInventory.issuePrice;
        this.amount = this.prodInventory.issueAmount;
      }
    } else {
      this.prodInventory.isReceive = this.isReceive;
      this.prodInventory.shopId = this.shopId;
      this.prodInventory.productId = this.product.id;

      if (this.isReceive) {
        this.price = this.product.costPrice ? this.product.costPrice : 0;
      } else {
        this.price = this.product.price ? this.product.price : 0;
      }
      this.summaryDetail();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //control events
  summaryDetail() {
    this.price = this.price ? parseFloat(this.price.toString()) : 0;
    this.amount = Number(this.quantity * this.price);
  }

  productQuantityIncrement(value) {
    this.quantity += value;
    this.summaryDetail();
  }

  cancel() {
    this.ref.close();
  }

  submit() {
    this.prodInventory.productCode = this.product.code || this.product.barcode;
    this.prodInventory.productName = this.product.title || "";
    this.prodInventory.productUnitName = this.product.unitName || "";

    if (this.isReceive) {
      this.prodInventory.receivePrice = Number(this.price);
      this.prodInventory.receiveQuantity = Number(this.quantity);
      this.prodInventory.receiveAmount = Number(this.amount);
      this.prodInventory.issuePrice = 0;
      this.prodInventory.issueQuantity = 0;
      this.prodInventory.issueAmount = 0;
    } else {
      this.prodInventory.receivePrice = 0;
      this.prodInventory.receiveQuantity = 0;
      this.prodInventory.receiveAmount = 0;
      this.prodInventory.issuePrice = Number(this.price);
      this.prodInventory.issueQuantity = Number(this.quantity);
      this.prodInventory.issueAmount = Number(this.amount);
    }
    this.prodInventory.issueDate = this.issueDate;
    this.isEdit ? this.update() : this.create();
  }

  //services
  private create() {
    this.loading = true;
    this.submitted = true;
    this.inventoryService
      .create(this.prodInventory)
      .then((data) => {
        this.prodInventory.id = data.id;

        this.productService.updateIndexedDbOverview(
          this.prodInventory.productId,
          this.isReceive,
          this.quantity,
          this.amount
        );

        this.ref.close(this.prodInventory);

        this.loading = false;
        this.submitted = false;
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  private update() {
    this.loading = true;
    this.submitted = true;
    this.inventoryService
      .update(this.prodInventory)
      .then((data) => {
        const quantity = this.isReceive
          ? this.prodInventory.receiveQuantity -
            this.prodInventoryBackup.receiveQuantity
          : this.prodInventory.issueQuantity -
            this.prodInventoryBackup.issueQuantity;

        console.log(
          "🚀 ~ DialogProductInventoryComponent ~ .then ~ quantity:",
          quantity
        );

        this.productService.updateIndexedDbOverview(
          this.prodInventory.productId,
          this.isReceive,
          quantity,
          this.amount
        );

        this.ref.close(this.prodInventory);

        this.loading = false;
        this.submitted = false;
      })

      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }
}
